import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';

export default function NotFoundPage() {
  return (
    <div className="relative min-h-screen flex items-center justify-center" data-testid="not-found-page">
      <div className="fixed inset-0 grid-pattern opacity-20 z-[1]" />

      <div className="relative z-10 text-center px-6">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <p className="font-rajdhani text-cyan-400 tracking-[0.4em] uppercase text-sm mb-4">
            404 — Page Not Found
          </p>

          <h1 className="font-orbitron text-7xl md:text-9xl font-black tracking-tighter text-white/10 mb-6">
            404
          </h1>

          <p className="font-rajdhani text-xl text-white/50 mb-10 max-w-md mx-auto">
            This page doesn't exist. Maybe you took a wrong turn in the matrix.
          </p>

          <Link
            to="/"
            className="inline-flex items-center gap-2 px-8 py-4 bg-cyan-500 text-black font-rajdhani font-bold tracking-wider uppercase hover:bg-cyan-400 transition-all cyber-clip"
            data-testid="not-found-home-link"
          >
            Back to Home
            <ArrowUpRight size={18} />
          </Link>
        </motion.div>
      </div>
    </div>
  );
}
